import React from 'react';
import clgImg from "../../../../assets/college-2.jpeg";

const ImageHeading = ({heading = ''}) => {
    const imgUrl = `url(${clgImg})`;
    return (
        <div className='page-banner' style={{backgroundImage: imgUrl}}>
            <div className='obvl-dark'>
                <div className='container'>
                    <div className='page-banner-entry'>
                        <h1 className='text-uppercase'>{heading}</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageHeading;